import { render, staticRenderFns } from "./DisplayInformation.vue?vue&type=template&id=f0c27862&scoped=true"
import script from "./DisplayInformation.vue?vue&type=script&lang=js"
export * from "./DisplayInformation.vue?vue&type=script&lang=js"
import style0 from "./DisplayInformation.vue?vue&type=style&index=0&id=f0c27862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c27862",
  null
  
)

export default component.exports